import React from 'react'
import SeoMeta from '../Common/SeoMeta'
import { getImages } from '../Common/const'
import { Link } from 'react-router-dom'
const CarServiceBoerneTexas = () => {
    return (
        <>
            <SeoMeta
                title="Luxury Vehicle Service in Boerne & Austin TX - The Mark Motors"
                description="Looking for a car service in Boerne & Austin Texas? Mark Motors can help with luxury brands such as Mercedes-Benz, Lamborghini, Porsche, Ferrari, Audi, Land Rover &amp; more"
                keywords=""
                ogTitle="Luxury Vehicle Service in Boerne & Austin TX - The Mark Motors"
                ogDescription="Looking for a car service in Boerne & Austin Texas? Mark Motors can help with luxury brands such as Mercedes-Benz, Lamborghini, Porsche, Ferrari, Audi, Land Rover &amp; more"
            />
            <section className='cm-wrap pt-200'>
                <div className='container'>
                    <div className="widget-paragraph text-start">
                        <img src={getImages('new/service-main-photo.jpg')} alt='' />

                        <h1>Luxury Vehicle Service in Boerne, TX</h1>
                        <p>At Mark Motors we understand that maintaining your vehicle is not the most exciting part of your day. Like you, we want you to focus on the important things in your life and let us take care of you and your service needs. We offer complimentary pick up
                            and delivery for all of our services so that you can be where you need to be. If you need another vehicle to drive while we have yours, you can have one of ours. Complimentary washes are included with service. We feel it is equally
                            important to maintain your vehicle’s best appearance and drivability together because a car that looks its best is a car that runs its best!
                            <strong>Our services include but are not limited to:</strong>
                        </p>
                        <ul>
                            <li>Oil Change</li>
                            <li>Factory Recommended Maintenance</li>
                            <li>Alignment</li>
                            <li>Brakes and Tires</li>
                            <li>Detail Services</li>
                            <li>Drivetrain Repair</li>
                            <li>Suspension Repair</li>
                            <li>Electrical Repair</li>
                            <li><strong>And More!</strong></li>
                        </ul>
                        <div className="mt-3">
                            <Link className="btn-theme md-btn me-4 d-inline-block" to="/schedule-car-maintenance-or-auto-repair-boerne-tx">Schedule Service</Link>
                        </div>
                        <div className='row gx-5 my-5'>
                            <div className='col-md-5'>
                                <img src={getImages('new/mark-motors-service-bottomnew_b3.jpg')} alt='' />
                            </div>
                            <div className='col-md-7'>
                                <h3>Schedule car service in </h3>
                                <p>Our technicians are trained to service your vehicle and receive continuous training so we are always up to date with all of the current and future automotive technologies. Our focus is to ensure a smooth ownership experience for you with your vehicle.
                                    We are not in the business of upselling parts and services you don’t need. We want to take care of your concerns first and keep your drive safe and reliable. Simply using any old oil filter will probably result in a loss in
                                    performance and could damage the engine. Factory approved parts, combined with regular maintenance keep cars running for a longer time. Everything at Mark Motors is designed around your experience. We have designed our service
                                    area to protect your vehicle, to keep your vehicle clean, and to guarantee you a delightful experience every time.
                                </p>
                            </div>
                        </div>
                        <p>Mark Motors would like to guide you through the process and work with you each step of the way. Please call us if you have maintenance or repair needs or concerns. It is our commitment to you to provide the highest level of service every time. We have
                            developed our culture around you and your needs. We act with your permission. We are here not only to service your vehicle, but to be of service to you.
                        </p>

                    </div>
                </div>
            </section>

        </>
    )
}

export default CarServiceBoerneTexas